<script setup>
import { computed } from 'vue';

const props = defineProps({
    context: {
        type: String,
        default: '',
    },
    listUrl: {
        type: String,
        default: '',
    },
});

const variants = {
    lead: {
        title: 'error:notFound.lead.title',
        description: 'error:notFound.lead.description',
        cta: 'error:notFound.lead.cta',
    },
    page: {
        title: 'error:notFound.page.title',
        description: 'error:notFound.page.description',
        cta: 'error:notFound.page.cta',
    },
    automation: {
        title: 'error:notFound.automation.title',
        description: 'error:notFound.automation.description',
        cta: 'error:notFound.automation.cta',
    },
    newsletter: {
        title: 'error:notFound.newsletter.title',
        description: 'error:notFound.newsletter.description',
        cta: 'error:notFound.newsletter.cta',
    },
    course: {
        title: 'error:notFound.course.title',
        description: 'error:notFound.course.description',
        cta: 'error:notFound.course.cta',
    },
};

const generalVariant = {
    title: 'error:notFound.title',
    description: 'error:notFound.description',
    cta: 'error:notFound.goToDashboard',
};

const variant = computed(() => variants[props.context] ?? generalVariant);
const ctaUrl = computed(() => props.listUrl || route('boIndex'));

const historyAvailable = window.history.length > 1;

const goBack = () => window.history.back();
</script>

<template>
    <div class="flex min-h-[60vh] flex-col items-center justify-center text-center">
        <h1 class="mb-2 text-6xl text-wlPrimary">404</h1>
        <h2 class="mb-2 text-xl">{{ _mft(variant.title) }}</h2>
        <p class="mb-6 text-gray-600">{{ _mft(variant.description) }}</p>
        <div class="flex justify-center space-x-4">
            <button-secondary
                v-if="historyAvailable"
                @click="goBack"
            >
                {{ _mft('error:notFound.goBack') }}
            </button-secondary>
            <a :href="ctaUrl" class="mf-link-immune">
                <button-primary>{{ _mft(variant.cta) }}</button-primary>
            </a>
        </div>
    </div>
</template>
